<template>
  <div id="app">
    <Index />
  </div>
</template>
<script>
  import Index from "./components/index.vue"
  export default {
    components: {
      Index
    }
  }
</script>
<style>
 body{
   margin: 0;
   padding: 0;
 }
 .container{
  width: 1200px;
  margin:0 auto
 }
</style>